<template>
  <!-- Account menu of a logged-in user, opened by the user button in the page navigation -->
  <ts-offcanvas id="auth-sidebar" panel-class="ts-notebook ts-account-menu" labelledby="auth-sidebar-title">
    <template #default="{ close }">
      <div class="offcanvas-header ts-panel-header">
        <div class="d-flex align-items-center gap-3 min-w-0">
          <div class="ts-panel-title-icon d-flex align-items-center justify-content-center flex-shrink-0">
            <i class="bi bi-person-circle" aria-hidden="true"></i>
          </div>
          <div class="min-w-0">
            <p class="small mb-0">{{ translations[2438] }}</p>
            <h2 id="auth-sidebar-title" class="offcanvas-title ts-panel-title fw-bold text-truncate">{{ userName }}</h2>
          </div>
        </div>
        <button class="btn-close" type="button" :aria-label="closeLabel" @click="close"></button>
      </div>

      <div class="offcanvas-body ts-panel-body">
        <nav class="d-flex flex-column gap-2" :aria-label="userName">
          <button class="btn ts-btn-outline-accent ts-account-menu-item" type="button" @click="openCabinet">
            <i class="bi bi-person-circle" aria-hidden="true"></i>
            <span>{{ translations[13797] }} ({{ roleText }})</span>
          </button>
          <button class="btn ts-btn-outline-accent ts-account-menu-item" type="button" @click="openNotebook(close)">
            <i class="bi bi-journal-bookmark" aria-hidden="true"></i>
            <span>{{ translations[10966] }}</span>
            <span class="badge rounded-pill ts-count-badge ms-auto">{{ notebookLength }}</span>
          </button>
          <!-- Not connected yet (as in the old menu) -->
          <button class="btn ts-btn-outline-accent ts-account-menu-item" type="button" disabled>
            <i class="bi bi-chat-square-text" aria-hidden="true"></i>
            <span>{{ translations[10997] }}</span>
          </button>
        </nav>
      </div>

      <div class="ts-panel-footer d-flex">
        <button class="btn btn-outline-danger ts-btn-sm" type="button" @click="logOut(close)">
          <i class="bi bi-power me-2" aria-hidden="true"></i>
          {{ translations[13575] }}
        </button>
      </div>
    </template>
  </ts-offcanvas>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { NotebookModule } from '@/store/modules/notebook';
import TsOffcanvas from '@/components/Talentspace/layout/TsOffcanvas.vue';

@Component({
  components: { TsOffcanvas },
})
export default class AuthSidebar extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get translations() {
    return AppModule.translation;
  }

  get closeLabel() {
    return AppModule.translation[2511];
  }

  // The name of whoever is logged in: applicant → consultant → company (one role at a time)
  get userName(): string {
    const applicant = UserModule.accessTokenApplicant && UserModule.userInfoApplicant?.applicant;
    if (applicant?.firstname) return `${applicant.firstname} ${applicant.lastname || ''}`.trim();
    const consultant = UserModule.accessTokenConsultant && UserModule.userInfoConsultant?.consultant;
    if (consultant) return `${consultant.firstname} ${consultant.lastname || ''}`.trim();
    if (UserModule.accessTokenCompany) return UserModule.userInfoCompany?.company?.company_name || '';
    return '';
  }

  get roleText(): string {
    if (UserModule.accessTokenApplicant) return this.translations[1135];
    if (UserModule.accessTokenCompany) return this.translations[3764];
    if (UserModule.accessTokenConsultant) return this.translations[13766];
    return '';
  }

  // Same count as the bookmark button in the page navigation
  get notebookLength(): number {
    return NotebookModule.notebookJobs.length
      + NotebookModule.notebookWorkers.length
      + NotebookModule.notebookCompany.length
      + NotebookModule.notebookCourses.length;
  }

  openCabinet() {
    this.$router.push({ name: 'Cabinet' }).catch(() => {});
  }

  openNotebook(close: () => void) {
    close();
    this.$root.$emit('bv::toggle::collapse', 'notebook-sidebar');
  }

  logOut(close: () => void) {
    if (UserModule.accessTokenApplicant) UserModule.LogOutApplicant(this.sid);
    if (UserModule.accessTokenConsultant) UserModule.LogOutConsultant(this.sid);
    if (UserModule.accessTokenCompany) UserModule.LogOutCompany(this.sid);
    close();
    this.$router.push({ path: '/' }).catch(() => {});
  }
}
</script>
